import { combineReducers } from 'redux';
import bundlesReducer from './bundlesSlice';
import productsReducer from './productsSlice';
import phnSubscriptionPlansReducer from './phnSubscriptionPlansSlice';
import smsPackagesReducer from './smsPackagesSlice';
import providersReducer from './providersSlice';
import csvImportsReducer from './csvImportsSlice';
import availablePhoneNumbersReducer from './availablePhoneNumbersSlice';
import phoneNumberPricesReducer from './phoneNumberPricesSlice';
import rateHistoriesReducer from './rateHistoriesSlice';
import phoneNumberPriceHistoriesReducer from './phoneNumberPriceHistoriesSlice';
import usersReducer from './usersSlice';
import userNumbersReducer from './userNumbersSlice';
import devicesReducer from './devicesSlice';
import ordersReducer from './ordersSlice';
import subscriptionsReducer from './subscriptionsSlice';
import userNumberSubscriptionsReducer from './userNumberSubscriptionsSlice';
import userNumberMessagesReducer from './userNumberMessagesSlice';
import cdrsReducer from './cdrsSlice';
import invoicesReducer from './invoicesSlice';
import coinLogsReducer from './coinLogsSlice';
import ratesReducer from './ratesSlice';

export default combineReducers({
  bundles: bundlesReducer,
  products: productsReducer,
  phnSubscriptionPlans: phnSubscriptionPlansReducer,
  smsPackages: smsPackagesReducer,
  providers: providersReducer,
  csvImports: csvImportsReducer,
  availablePhoneNumbers: availablePhoneNumbersReducer,
  phoneNumberPrices: phoneNumberPricesReducer,
  rateHistories: rateHistoriesReducer,
  phoneNumberPriceHistories: phoneNumberPriceHistoriesReducer,
  users: usersReducer,
  userNumbers: userNumbersReducer,
  devices: devicesReducer,
  orders: ordersReducer,
  subscriptions: subscriptionsReducer,
  userNumberSubscriptions: userNumberSubscriptionsReducer,
  userNumberMessages: userNumberMessagesReducer,
  cdrs: cdrsReducer,
  invoices: invoicesReducer,
  coinLogs: coinLogsReducer,
  rates: ratesReducer,
})
